<template>
  <div class="relative inline-block">
    <select
      :id="label"
      v-model="selected"
      @change="$emit('input', $event.target.value)"
      class="ot-dropdown pr-8 w-full appearance-none"
      :class="selectClass"
    >
      <option
        v-for="item in options"
        :key="item.id"
        :value="item.id"
        :disabled="
          item.disabled && !(item.enabledPolicies && $route.name === 'policy')
        "
      >
        {{ hasTranslation ? $t(item.name) : item.name }}
      </option>
    </select>
    <div
      class="pointer-events-none absolute inset-y-0 right-0 pr-4 flex items-center"
    >
      <font-awesome-icon :icon="['fas', 'angle-down']" class="text-gray-400" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: "",
    },
    value: {
      type: [String, Number],
      default: "",
    },
    options: {
      type: Array,
      default: null,
    },
    selectClass: {
      type: String,
      default: "",
    },
    hasTranslation: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selected: this.value,
    };
  },
  watch: {
    value() {
      this.selected = this.value;
    },
  },
};
</script>

<style></style>
